import React from 'react';
import { useTranslation } from 'react-i18next';

import EmailSentIcon from '../../../../../icons/components/EmailSentIcon';

import scss from '../Steps.module.scss';
import CommonButton, { BUTTON_STYLES } from '../../../../../components/common-button/CommonButton';

function StepMessageSent({ onClose }) {
  const { t } = useTranslation('contact');

  return (
    <div className={scss.stepFormWrapper}>
      <div className={scss.emailContent}>
        <div className={scss.emailContentText}>
          <h3>{t('emailWasSent')}</h3>
          <h4>{t('weWillGetBackToYou')}</h4>
        </div>

        <EmailSentIcon className={scss.emailSentIcon} />
      </div>

      <CommonButton styleColor={BUTTON_STYLES.PRIMARY} maxWidth={190} onClick={onClose}>
        {t('close')}
      </CommonButton>
    </div>
  );
}

export default StepMessageSent;
